var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.flag == _vm.index && _vm.detailShow
    ? _c(
        "div",
        {
          staticClass: "transfers-detail",
          style: {
            height:
              _vm.transferDetail.stateSet && _vm.transferDetail.stateSet.length
                ? _vm.transferDetail.stateSet.length * 25 +
                  _vm.detailHeight +
                  "px"
                : _vm.detailHeight + "px"
          }
        },
        [
          _c("div", { staticClass: "transfers-detail-title" }, [
            _vm.item.tranferWay == "restore"
              ? _c("span", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("language.cloudBackup.restoreDetails")) +
                      " "
                  )
                ])
              : _c("span", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("language.cloudBackup.backupDetails")) +
                      " "
                  )
                ])
          ]),
          _vm._v(" "),
          _vm.transferDetail.runningStatus == 1
            ? _c("div", { staticClass: "detail-count" }, [
                _c("div", { staticClass: "transfer-line" }, [
                  _vm._v(
                    _vm._s(_vm.$t("language.common.countFiles")) +
                      ":(" +
                      _vm._s(_vm.transferDetail.readyFindFileCount) +
                      _vm._s(_vm.$t("language.common.transferFiles")) +
                      "," +
                      _vm._s(
                        _vm._f("formatByte")(_vm.transferDetail.totalBytes)
                      ) +
                      ")"
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "detail-one" }, [
            (_vm.item.tranferWay == "restore" ||
              _vm.item.tranferWay == "retry-restore") &&
            (_vm.item.status == "Running" || _vm.item.status == "Waiting")
              ? _c("span", [
                  _c(
                    "div",
                    {
                      staticClass: "transfer-line",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.toRestoreSource(_vm.item)
                        }
                      }
                    },
                    [
                      _c("span", { staticStyle: { float: "left" } }, [
                        _vm._v(_vm._s(_vm.$t("language.common.from")) + ":")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "catelog-color catelog-style",
                          attrs: {
                            title: _vm._f("getCatalog")(_vm.item.fromItem.nodes)
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm._f("getCatalog")(_vm.item.fromItem.nodes)
                            )
                          )
                        ]
                      )
                    ]
                  )
                ])
              : _c("span", [
                  !_vm.transferDetail.sourceNode.data
                    ? _c(
                        "div",
                        {
                          staticClass: "transfer-line",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.toSourceCatalog(_vm.transferDetail)
                            }
                          }
                        },
                        [
                          _c("span", { staticStyle: { float: "left" } }, [
                            _vm._v(_vm._s(_vm.$t("language.common.from")) + ":")
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "catelog-color catelog-style",
                              attrs: {
                                title: _vm._f("getCatalogTitle")(
                                  _vm._f("getCatalog")(
                                    _vm.transferDetail.sourceNode
                                  )
                                )
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("getCatalog")(
                                    _vm.transferDetail.sourceNode
                                  )
                                )
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.transferDetail.sourceNode.data &&
                  _vm.transferDetail.sourceNode.data.length
                    ? _c(
                        "div",
                        {
                          staticClass: "transfer-line",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.openBackupSource(
                                _vm.transferDetail.sourceNode
                              )
                            }
                          }
                        },
                        [
                          _c("span", { staticStyle: { float: "left" } }, [
                            _vm._v(_vm._s(_vm.$t("language.common.from")) + ":")
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "catelog-color catelog-style",
                              attrs: {
                                title: _vm._f("getBackupInfo")(
                                  _vm._f("getCatalog")(
                                    _vm.transferDetail.sourceNode.data[0].nodes
                                  )
                                )
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("getBackupInfo")(
                                    _vm._f("getCatalog")(
                                      _vm.transferDetail.sourceNode.data[0]
                                        .nodes
                                    )
                                  )
                                )
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ]),
            _vm._v(" "),
            (_vm.item.tranferWay == "restore" ||
              _vm.item.tranferWay == "retry-restore") &&
            (_vm.item.status == "Running" || _vm.item.status == "Waiting")
              ? _c("span", [
                  _vm.item.toItem
                    ? _c("span", [
                        _vm.item.toItem.data && _vm.item.toItem.data.length
                          ? _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass: "transfer-line",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.openBackupToItems(
                                        _vm.item.toItem
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { float: "left" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("language.common.to")) +
                                          ":"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "catelog-color catelog-style",
                                      attrs: {
                                        title: _vm._f("getBackupInfo")(
                                          _vm._f("getCatalog")(
                                            _vm.item.toItem.data[0].nodes
                                          )
                                        )
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("getBackupInfo")(
                                            _vm._f("getCatalog")(
                                              _vm.item.toItem.data[0].nodes
                                            )
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          : _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass: "transfer-line",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.toRestoreAimCatalog(
                                        _vm.item.toItem
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { float: "left" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("language.common.to")) +
                                          ":"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "catelog-color catelog-style",
                                      attrs: {
                                        title: _vm._f("getCatalog")(
                                          _vm.item.toItem.nodes
                                        )
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("getCatalog")(
                                            _vm.item.toItem.nodes
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                      ])
                    : _c("span", [
                        _c(
                          "div",
                          {
                            staticClass: "transfer-line",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.toRestoreOriginalAimCatalog(_vm.item)
                              }
                            }
                          },
                          [
                            _c("span", { staticStyle: { float: "left" } }, [
                              _vm._v(_vm._s(_vm.$t("language.common.to")) + ":")
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "catelog-color catelog-style",
                                attrs: { title: "Original" }
                              },
                              [_vm._v("Original")]
                            )
                          ]
                        )
                      ])
                ])
              : _c("span", [
                  !_vm.transferDetail.desNode.data
                    ? _c(
                        "div",
                        {
                          staticClass: "transfer-line",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.toAimCatalog(_vm.transferDetail)
                            }
                          }
                        },
                        [
                          _c("span", { staticStyle: { float: "left" } }, [
                            _vm._v(_vm._s(_vm.$t("language.common.to")) + ":")
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "catelog-color catelog-style",
                              attrs: {
                                title: _vm._f("getCatalogTitle")(
                                  _vm._f("getCatalog")(
                                    _vm.transferDetail.desNode
                                  )
                                )
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("getCatalog")(
                                    _vm.transferDetail.desNode
                                  )
                                )
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.transferDetail.desNode.data &&
                  _vm.transferDetail.desNode.data.length
                    ? _c(
                        "div",
                        {
                          staticClass: "transfer-line",
                          attrs: {
                            title: _vm._f("getBackupInfo")(
                              _vm._f("getCatalog")(
                                _vm.transferDetail.desNode.data[0].nodes
                              )
                            )
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.openBackupSource(
                                _vm.transferDetail.desNode
                              )
                            }
                          }
                        },
                        [
                          _c("span", { staticStyle: { float: "left" } }, [
                            _vm._v(_vm._s(_vm.$t("language.common.to")) + ":")
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "catelog-color catelog-style",
                              attrs: {
                                title: _vm._f("getBackupInfo")(
                                  _vm._f("getCatalog")(
                                    _vm.transferDetail.desNode.data[0].nodes
                                  )
                                )
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("getBackupInfo")(
                                      _vm._f("getCatalog")(
                                        _vm.transferDetail.desNode.data[0].nodes
                                      )
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "detail-two" }, [
            _c("div", { staticClass: "transfer-line" }, [
              _vm._v(
                _vm._s(_vm.$t("language.common.fileProcess")) +
                  ":\r\n            "
              ),
              _vm.transferDetail.runningStatus != 0
                ? _c("span", [
                    _vm._v(_vm._s(_vm.transferDetail.readyTranFileCount)),
                    _vm.transferDetail.readyTranFileCount != null &&
                    _vm.transferDetail.readyFindFileCount != null
                      ? _c("span", [_vm._v("/")])
                      : _vm._e(),
                    _vm._v(_vm._s(_vm.transferDetail.readyFindFileCount))
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "transfer-line" }, [
              _c("span", { staticClass: "transfer-column-left" }, [
                _vm._v(
                  _vm._s(_vm.$t("language.common.dataProcess")) +
                    ":\r\n                "
                ),
                _vm.transferDetail.runningStatus != 0
                  ? _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("formatByte")(
                              _vm.transferDetail.totalReadedBytes
                            )
                          )
                      ),
                      _vm.transferDetail.totalReadedBytes != null &&
                      _vm.transferDetail.totalBytes != null
                        ? _c("span", [_vm._v("/")])
                        : _vm._e(),
                      _vm._v(
                        _vm._s(
                          _vm._f("formatByte")(_vm.transferDetail.totalBytes)
                        )
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "transfer-column-right" }, [
                _vm._v(_vm._s(_vm.$t("language.popup.progress")) + ":"),
                _vm.transferDetail.runningStatus > 1
                  ? _c("span", [_vm._v(_vm._s(_vm.percent + "%"))])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "transfer-line" }, [
              _c("span", { staticClass: "transfer-column-left" }, [
                _vm._v(
                  _vm._s(_vm.$t("language.common.startTime")) +
                    ":\r\n                "
                ),
                _vm.transferDetail.runningStatus != 0
                  ? _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("transferTime")(
                            _vm.transferDetail.taskStartTimeLong
                          )
                        )
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "transfer-column-right" }, [
                _vm._v(_vm._s(_vm.$t("language.common.currentRate")) + ": "),
                _vm.transferDetail.runningStatus > 1
                  ? _c("span", [_vm._v(_vm._s(_vm.speed))])
                  : _vm._e()
              ])
            ])
          ]),
          _vm._v(" "),
          _vm.transferDetail && _vm.transferDetail.stateSet
            ? _c(
                "div",
                {
                  staticClass: "detail-three",
                  style: {
                    height:
                      _vm.transferDetail.stateSet &&
                      _vm.transferDetail.stateSet.length
                        ? _vm.transferDetail.stateSet.length * 25 + 20 + "px"
                        : "0px"
                  }
                },
                _vm._l(_vm.transferDetail.stateSet, function(sitem, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "transfer-line",
                      staticStyle: { float: "left" }
                    },
                    [
                      _vm.item.tranferWay == "restore" && sitem.sourcePath
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "transfer-column-left transfering-file-line",
                              attrs: { title: sitem.sourcePath }
                            },
                            [
                              _vm._v(
                                "\r\n                " +
                                  _vm._s(sitem.sourcePath) +
                                  "\r\n            "
                              )
                            ]
                          )
                        : _c(
                            "span",
                            {
                              staticClass:
                                "transfer-column-left transfering-file-line",
                              attrs: { title: _vm.getTitle(sitem) }
                            },
                            [
                              _vm._v(
                                "\r\n                " +
                                  _vm._s(_vm._f("getCatalog")(sitem.pnodes)) +
                                  "\\" +
                                  _vm._s(sitem.itemName) +
                                  "\r\n            "
                              )
                            ]
                          ),
                      _vm._v(" "),
                      !_vm.isVip()
                        ? _c("span", [
                            sitem.status != 0
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "transfer-column-right transfering-file-line upgradeMulti",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.switchToPay()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("language.common.upgradeMulti")
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            sitem.status == 0
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "transfer-column-right transfering-file-line"
                                  },
                                  [_vm._v(_vm._s(_vm.getItemRate(sitem)) + "%")]
                                )
                              : _vm._e()
                          ])
                        : _c("span", [
                            _vm.getItemRate(sitem) && sitem.status == 0
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "transfer-column-right transfering-file-line"
                                  },
                                  [_vm._v(_vm._s(_vm.getItemRate(sitem)) + "%")]
                                )
                              : _c(
                                  "span",
                                  {
                                    staticClass:
                                      "transfer-column-right transfering-file-line"
                                  },
                                  [_vm._v("0%")]
                                )
                          ])
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "detail-four" }, [
            _c("div", { staticClass: "transfer-line" }, [
              _c("div", {
                staticClass: "icon-util shop-cart shop-cart-position"
              }),
              _vm._v(" "),
              _vm.item.tranferWay == "restore"
                ? _c("div", [
                    _vm.isVip()
                      ? _c("span", { staticClass: "transfer-line-des" }, [
                          _vm._v(
                            _vm._s(_vm.$t("language.cloudBackup.thankRestore"))
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isVip()
                      ? _c("span", { staticClass: "transfer-line-des" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("language.cloudBackup.restoreSimult")
                            ) + " "
                          )
                        ])
                      : _vm._e()
                  ])
                : _c("div", [
                    _vm.isVip()
                      ? _c("span", { staticClass: "transfer-line-des" }, [
                          _vm._v(
                            _vm._s(_vm.$t("language.cloudBackup.thankSubscrib"))
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isVip()
                      ? _c("span", { staticClass: "transfer-line-des" }, [
                          _vm._v(
                            _vm._s(_vm.$t("language.cloudBackup.maximunBack")) +
                              " "
                          )
                        ])
                      : _vm._e()
                  ])
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            !_vm.isVip()
              ? _c("div", { staticClass: "transfer-line" }, [
                  _c(
                    "button",
                    {
                      staticClass: "upgrade-now",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.switchToPay()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("language.common.upgradeNow")))]
                  )
                ])
              : _vm._e()
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7dfda658", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dfda658","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tabs/tabs_task_list/tabs_backup_detail.vue
// module id = null
// module chunks = 